<template>
    <div>
      <input 
        type="file" 
        accept="image/*" 
        ref="fileInput" 
        @change="handleFileUpload" 
        class="d-none"
        id="imageInput"
      >
      <button type="button" for="imageInput" @click="triggerFileInput" class="btn btn-primary">
        <i class="fas fa-upload me-2"></i>Sélectionner une image
      </button>
      
      <!-- <div v-if="previewUrl" class="mt-3">
        <img :src="previewUrl" class="img-thumbnail" style="max-height: 200px;">
      </div>
      
      <button type="button"
        v-if="file" 
        @click="uploadImage" 
        class="btn btn-success mt-3"
        :disabled="uploading"
      >
        <span v-if="!uploading">Envoyer l'image</span>
        <span v-else>
          <span class="spinner-border spinner-border-sm" role="status"></span>
          Envoi en cours...
        </span>
      </button> -->
      
      <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    props: {
      modelName: {
        type: String,
        required: true
      },
      existingImage: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        file: null,
        previewUrl: null,
        uploading: false,
        error: null
      };
    },
    methods: {
      triggerFileInput() {
        this.$refs.fileInput.click();
      },
      handleFileUpload(event) {
        this.file = event.target.files[0];
        if (!this.file) return;
        
        // Créer une preview
        this.previewUrl = URL.createObjectURL(this.file);
        this.uploadImage()
      },
      async uploadImage() {
        if (!this.file) return;
        
        this.uploading = true;
        this.error = null;
        
        try {
          const formData = new FormData();
          formData.append('image', this.file);
          formData.append('model', this.modelName);
          
          if (this.existingImage) {
            formData.append('existing', this.existingImage);
          }
          
          const response = await axios.post('/api/upload-image', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          
          if (response.data.success) {
            this.$emit('image-uploaded', response.data.url);
          } else {
            this.error = response.data.message || 'Erreur lors de l\'envoi';
          }
        } catch (error) {
          this.error = this.handleError(error);
        } finally {
          this.uploading = false;
        }
      },
      handleError(error) {
        if (error.response) {
          if (error.response.status === 413) {
            return 'Fichier trop volumineux (max 2MB)';
          }
          return error.response.data.message || 'Erreur serveur';
        }
        return 'Erreur de connexion';
      }
    }
  };
  </script>